import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

const SKIP_REFRESH = ["/auth/login", "/auth/refresh", "/auth/register", "/auth/logout"];
let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const url = original?.url || "";
    const shouldTry =
      error.response?.status === 401 &&
      original &&
      !original._retry &&
      !SKIP_REFRESH.some((p) => url.includes(p));

    if (!shouldTry) return Promise.reject(error);

    original._retry = true;
    try {
      if (!refreshing) {
        refreshing = api.post("/auth/refresh").finally(() => { refreshing = null; });
      }
      await refreshing;
      return api(original);
    } catch (e) {
      const isMeCheck = url.includes("/auth/me");
      if (
        !isMeCheck &&
        typeof window !== "undefined" &&
        !window.location.pathname.startsWith("/login")
      ) {
        window.location.href = "/login";
      }
      return Promise.reject(e);
    }
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
